export enum ClickStreamEventType {
    IMPRESSION = 'Impression',
    OUTCOME = 'Outcome',
    INTERACTION = 'Interaction',
    PRESENTED = 'Presented',
    HIDDEN = 'Hidden',
}

export interface ClickStreamEventConstants {
    EVENT_TYPE?: ClickStreamEventType;
    EVENT_CATEGORY?: string;
    EVENT_NAME?: string;
    EVENT_VERSION?: string;
    EVENT_ACTION_REASON?: string;
    EVENT_LOCATION?: string;
    PAGE_NAME?: string;
    USER_INTERFACES?: {};
    VIDEO_LIST?: {};
    EXTRA_DATA?: {};
    ARTICLE?: {};
}

export const clickstreamDataJSON = (eventType: ClickStreamEventType, eventCategory, eventName, componentName = "", componentElementName = "", direction = "", eventActionReason = "",
        eventActionLocation = "", link = "", extraData = {}

) => {
    const clickstreamData: ClickStreamEventConstants = {
      EVENT_TYPE: eventType,
      EVENT_CATEGORY: eventCategory,
      EVENT_NAME: eventName,
      EVENT_LOCATION: eventActionLocation,
      ...(eventActionReason && { EVENT_ACTION_REASON: eventActionReason }),
      EXTRA_DATA: extraData,
      //...(link && {ARTICLE: { article_link: link }}),
    };   
    
    return JSON.stringify(clickstreamData);
  };
